var path = '/app/components/dialogs/puzzle/puzzle.html';
var html = "<div class=custom-modal-wrap> <div class=custom-modal> <a class=btn-close ng-click=$ctrl.cancel()></a> <div class=modal-header>{{$ctrl.resolve.title}}</div> <div class=modal-body id=modal-body> <puzzle class=transparent></puzzle> </div> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dialogs/puzzle/puzzle.html
// module id = 201
// module chunks = 0